import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

/**
 * useRecaptcha — safely execute reCAPTCHA v3.
 * Returns a function that resolves to a token, or null if reCAPTCHA is not loaded (dev mode).
 */
export function useRecaptcha() {
  const { executeRecaptcha } = useGoogleReCaptcha();
  return async (action) => {
    if (!executeRecaptcha) return null;
    try {
      return await executeRecaptcha(action);
    } catch {
      return null;
    }
  };
}
